import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchExpenses(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, value);
  });
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiFetch(`/api/v1/expenses${suffix}`);
}

export function fetchUpcomingExpenses(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, value);
  });
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiFetch(`/api/v1/expenses/upcoming${suffix}`);
}

export function createExpense(payload) {
  return apiFetch("/api/v1/expenses", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateExpense(id, payload) {
  return apiFetch(`/api/v1/expenses/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteExpense(id) {
  return apiFetch(`/api/v1/expenses/${id}`, {
    method: "DELETE",
  });
}

export function uploadExpenseTickets(id, tickets) {
  return apiFetch(`/api/v1/expenses/${id}/tickets`, {
    method: "POST",
    body: stringifySnake({ tickets }),
  });
}

export function deleteExpenseTicket(id, resourceId) {
  return apiFetch(`/api/v1/expenses/${id}/tickets/${resourceId}`, {
    method: "DELETE",
  });
}

export function fetchRecurringExpenses(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, value);
  });
  const suffix = search.toString() ? `?${search.toString()}` : "";
  return apiFetch(`/api/v1/expenses/recurring${suffix}`);
}

export function createRecurringExpense(payload) {
  return apiFetch("/api/v1/expenses/recurring", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateRecurringExpense(id, payload) {
  return apiFetch(`/api/v1/expenses/recurring/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteRecurringExpense(id) {
  return apiFetch(`/api/v1/expenses/recurring/${id}`, {
    method: "DELETE",
  });
}

export function fetchExpenseProviders() {
  return apiFetch("/api/v1/expenses/providers");
}

export function fetchExpenseCategories() {
  return apiFetch("/api/v1/expenses/categories");
}

export function createExpenseProvider(payload) {
  return apiFetch("/api/v1/expenses/providers", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function createExpenseCategory(payload) {
  return apiFetch("/api/v1/expenses/categories", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateExpenseProvider(id, payload) {
  return apiFetch(`/api/v1/expenses/providers/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function updateExpenseCategory(id, payload) {
  return apiFetch(`/api/v1/expenses/categories/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteExpenseProvider(id) {
  return apiFetch(`/api/v1/expenses/providers/${id}`, {
    method: "DELETE",
  });
}

export function deleteExpenseCategory(id) {
  return apiFetch(`/api/v1/expenses/categories/${id}`, {
    method: "DELETE",
  });
}
